// sherlock-point.js
import SherlockConstant, {
  initialPointStatusState,
} from "@/mixins/sherlock/const/sherlockConstant.js";
import SherlockAcConstant from "@/mixins/sherlock/const/sherlockAcConstant.js";
import { callGetApi, callPostApi, callPatchApi, callDeleteApi } from "@/utils/apiWrapper";

export const state = {
  _point: {
    products: [], // 배열로 초기화 (filter 메서드 사용을 위해)
    pointStatus: initialPointStatusState,
    pointHistory: [], // 배열로 초기화
  },
};

export const mutations = {
  [SherlockConstant.SHERLOCK_POINT_PRODUCTS](state, products) {
    state._point.products = [];
    if (products?.length) {
      state._point.products = products;
    }
    // window.console.log("[mutations] SherlockConstant.SHERLOCK_POINT_PRODUCTS", state._point.products);
  },
  [SherlockConstant.SHERLOCK_POINT_STATUS](state, pointStatus) {
    state._point.pointStatus = initialPointStatusState;
    state._point.pointStatus = pointStatus;
  },
  [SherlockConstant.SHERLOCK_POINT_HISTORY](state, pointHistory) {
    state._point.pointHistory = [];
    if (pointHistory?.length) {
      state._point.pointHistory = pointHistory;
    }
  },
};

export const actions = {
  /**************************************************************
   * 포인트 상품 목록 조회
   **************************************************************/
  async acGetSherlockProductList({ commit }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_PRODUCT_LIST}`,
      params: {},
      commit,
    });
    // window.console.log("[acGetSherlockProductList] res: ", res);
    commit(SherlockConstant.SHERLOCK_POINT_PRODUCTS, res.products.point);
    return res;
  },

  /**************************************************************
   * 포인트 상태 조회
   **************************************************************/
  async acGetSherlockPointStatus({ commit }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_POINT_STATUS}`,
      params: {},
      commit,
    });
    // window.console.log("[acGetSherlockPointStatus] res: ", res);
    commit(SherlockConstant.SHERLOCK_POINT_STATUS, res.pointStatus);
  },

  /**************************************************************
   * 포인트 내역 조회
   **************************************************************/
  async acGetSherlockPointHistory({ commit }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_POINT_HISTORY}`,
      params: {},
      commit,
    });
    // window.console.log("[acGetSherlockPointHistory] res: ", res);
    commit(SherlockConstant.SHERLOCK_POINT_HISTORY, res.pointHistory?.history);
  },

  /**************************************************************
   * 포인트 전환
   * ticket_count, // 이용권 -> 포인트로 전환할 이용권 개수
   **************************************************************/
  async acPostSherlockPointConvert({ commit }, { ticket_count }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_POINT_CONVERT}`,
      data: {
        ticket_count,
      },
      commit,
    });
    // window.console.log("[acPostSherlockPointConvert] res: ", res);
    return res;
  },

  /**************************************************************
   * 결제 빌링키 조회
   **************************************************************/
  async acGetSherlockBillingKey({ commit }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_BILLING_KEY}`,
      params: {},
      commit,
    });
    // window.console.log("[acGetSherlockBillingKey] res: ", res);
    return res;
  },

  /**************************************************************
   * 결제 페이플 정보 조회
   * product_code, // 셜록 상품 코드
   **************************************************************/
  async acGetSherlockPaypleInfo({ commit }, { product_code }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_PAYPLE_INFO}`,
      params: {
        product_code,
      },
      commit,
    });
    // window.console.log("[acGetPaypleInfo] res: ", res);
    return res;
  },

  /**************************************************************
   * 결제 시작
   * user_no, // 유저 번호.
   * price, // 결제 금액.
   * pg_name, // PG사.
   * product_code, // 셜록 상품 코드.
   * merchant_uid, // payple_info 에서 획득한 주문번호.
   * use_billing_key, // 빌링키 사용 여부 -- false일 경우 카드 등록 새로 한 후 결제.
   **************************************************************/
  async acPostSherlockPaymentInit(
    { commit },
    { user_no, price, pg_name, product_code, merchant_uid, use_billing_key },
  ) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_PAYMENT_INIT}`,
      data: {
        user_no,
        price,
        pg_name,
        product_code,
        merchant_uid,
        use_billing_key,
      },
    });
    // window.console.log("[acPostSherlockPaymentInit] res: ", res);
    return res;
  },

  /**************************************************************
   * 결제 빌링키로 결제
   * merchant_uid, // 빌링키로 결제시킬 주문 번호.
   **************************************************************/
  async acPostSherlockPaymentBillingKey({ commit }, { merchant_uid }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_PAYMENT_BILLING_KEY}`,
      data: {
        merchant_uid,
      },
    });
    // window.console.log("[acPostSherlockPaymentBillingKey] res: ", res);
    return res;
  },

  /**************************************************************
   * 결제 PortOne(카카오페이) 빌링키로 결제
   * merchant_uid: 주문 번호
   * (billing_key는 백엔드에서 자동 조회)
   **************************************************************/
  async acPostSherlockPortoneBillingKey({ commit }, { merchant_uid }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_PORTONE_BILLING_KEY}`,
      data: {
        merchant_uid,
      },
    });
    return res;
  },

  /**************************************************************
   * 셜록 페이플 카드 등록 (FE callback 직통)
   * 페이플 server-to-server callback 이 환경 의존(어드민 webhook 누락 등) 으로
   * 누락되어도 user_billing_card 가 채워지도록 FE callback 응답을 BE 에 직접 전달.
   **************************************************************/
  async acPostSherlockPaypleCardRegister(
    { commit },
    { billing_key, merchant_uid, bank_name, bank_no },
  ) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_PAYPLE_CARD_REGISTER}`,
      params: {},
      data: {
        billing_key,
        merchant_uid,
        bank_name,
        bank_no,
      },
      commit,
    });
    return res;
  },

  /**************************************************************
   * 등록된 카드 목록 조회 (다중 카드 지원)
   **************************************************************/
  async acGetSherlockCards({ commit }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_CARDS}`,
      params: {},
      commit,
    });
    // window.console.log("[acGetSherlockCards] res: ", res);
    return res;
  },

  /**************************************************************
   * 카드 삭제
   * cardSeq, // 삭제할 카드 시퀀스
   **************************************************************/
  async acDeleteSherlockCard({ commit }, { cardSeq }) {
    const res = await callDeleteApi({
      url: `${SherlockAcConstant.DELETE_SHERLOCK_CARD}/${cardSeq}`,
      params: {},
      commit,
    });
    // window.console.log("[acDeleteSherlockCard] res: ", res);
    return res;
  },

  /**************************************************************
   * 기본 카드 변경
   * cardSeq, // 기본 카드로 설정할 카드 시퀀스
   **************************************************************/
  async acPatchSherlockDefaultCard({ commit }, { cardSeq }) {
    const res = await callPatchApi({
      url: `${SherlockAcConstant.PATCH_SHERLOCK_DEFAULT_CARD}/${cardSeq}/default`,
      data: {},
      commit,
    });
    // window.console.log("[acPatchSherlockDefaultCard] res: ", res);
    return res;
  },

  /**************************************************************
   * 다주택조회 포인트 사용 가능 여부 조회
   **************************************************************/
  async acPostSherlockAskDealOwnerProperties({ commit }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_ASK_DEAL_OWNER_PROPERTIES}`,
      data: {},
    });
    // window.console.log("[acPostSherlockAskDealOwnerProperties] res: ", res);
    return res;
  },

  /**************************************************************
   * 등기부조회 포인트 사용 가능 여부 조회
   * count, // 등기부 조회 희망하는 주소 건수.
   **************************************************************/
  async acPostSherlockAskDealEstateDocument({ commit }, { count }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_ASK_DEAL_ESTATE_DOCUMENT}`,
      data: {
        count,
      },
    });
    // window.console.log("[acPostSherlockAskDealEstateDocument] res: ", res);
    return res;
  },

  /**************************************************************
   * 주소지 조회 포인트 사용 가능 여부 조회
   * count, // 주소지 조회 희망하는 주소 건수.
   **************************************************************/
  async acPostSherlockDealAskAddressSearch({ commit }, { count }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_DEAL_ASK_ADDRESS_SEARCH}`,
      data: {
        count,
      },
    });
    // window.console.log("[acPostSherlockAskDealAddressSearch] res: ", res);
    return res;
  },

  /**************************************************************
   * 셜록 포인트 충전 - PortOne 정보 조회 (카카오페이용)
   * product_code, // 셜록 상품 코드
   **************************************************************/
  async acGetSherlockPortoneInfo({ commit }, { product_code }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_PORTONE_INFO}`,
      params: {
        product_code,
      },
      commit,
    });
    // window.console.log("[acGetSherlockPortoneInfo] res: ", res);
    return res;
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
